import { IRootState } from '../../../store'
import { IScrollToTopState } from '../store/scrollToTop.types'

export const getScrollToTopSelector = (state: IRootState): IScrollToTopState => state.scrollToTop
